
import { Label } from '@/components/ui/label';
import { Slider } from '@/components/ui/slider';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { BorderSettings } from '@/utils/pdf-templates/types';

interface Props {
    borders: BorderSettings;
    onChange: (val: BorderSettings) => void;
}

export function BorderStyleSettings({ borders, onChange }: Props) {
    const update = (key: keyof BorderSettings, value: number | string) => {
        onChange({ ...borders, [key]: value });
    };

    return (
        <div className="space-y-5">
            <div>
                <div className="flex justify-between mb-2">
                    <Label>سمك الحدود</Label>
                    <span className="text-sm text-muted-foreground font-mono">{borders.width}px</span>
                </div>
                <Slider min={0} max={5} step={0.5} value={[borders.width]} onValueChange={([v]) => update('width', v)} />
            </div>
            <div>
                <div className="flex justify-between mb-2">
                    <Label>نصف قطر الزوايا</Label>
                    <span className="text-sm text-muted-foreground font-mono">{borders.radius}px</span>
                </div>
                <Slider min={0} max={24} step={1} value={[borders.radius]} onValueChange={([v]) => update('radius', v)} />
            </div>
            <div>
                <Label className="mb-2 block">نمط الحدود</Label>
                <Select value={borders.style} onValueChange={(v) => update('style', v)}>
                    <SelectTrigger>
                        <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="solid">مستمر (Solid)</SelectItem>
                        <SelectItem value="dashed">متقطع (Dashed)</SelectItem>
                        <SelectItem value="dotted">منقط (Dotted)</SelectItem>
                        <SelectItem value="none">بدون حدود</SelectItem>
                    </SelectContent>
                </Select>
            </div>
        </div>
    );
}
